import React, { useContext, Fragment, useCallback, useMemo, useState, useRef } from 'react';
import { LocalizationContext } from 'app/localization/Context';
import { CurrentPageContext } from 'app/home/general-components/HistoryStackContext';
import { AIChatStatus } from 'app/model/AIChat';
// import TextLoop from "react-text-loop";

import CustomIconBack from 'app/home/home-components/CustomIconBack';
import { ReactComponent as IconX } from 'images/general/x.svg';

import { ReactComponent as IconNewChat } from 'images/chat/new-chat.svg';

import { ReactComponent as AIWand } from 'images/chat/wand.svg';
// import { ReactComponent as AIWandBorder} from 'images/chat/wand-border.svg';
import { ReactComponent as AIMicListening } from 'images/chat/listening.svg';
import { ReactComponent as AIMicThinking } from 'images/chat/thinking.svg';
import { ReactComponent as AIMicIdle } from 'images/chat/idle.svg';
import { ReactComponent as AIMicError } from 'images/chat/error.svg';

import { ReactComponent as IconSpeak } from 'images/chat/speak.svg';
import { ReactComponent as IconPause } from 'images/chat/pause.svg';

import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm'; // tables in markdown

import './AIChat.scss'
import { NewLogCell } from 'app/home/main-pages/reports/Reports';

import packageJson from '../../../../../package.json';


const InfoPlacement = {
    NoInfo: 0,
    TopOfChatInput: 1,
    InsteadOfChatInput: 2
}

export default function AIChat({ aiChat, showBackground, blurBackground, showSecondsInLog }) {
    const p = useContext(CurrentPageContext);
    const l = useContext(LocalizationContext);
    const s = l.strings;
    const [chatInput, setChatInput] = useState("");

    const isStaging = (packageJson.serverName === "staging");

    const { startListening, addNewMessage, clearChat, status, messages, stats } = aiChat;

    const processedMessages = useMemo(() => {
        let _processedMessages = [];
        for (let i = 0; i < messages.length; i++) {
            const current = messages[i];
            let last;
            if (_processedMessages.length - 1 >= 0) {
                last = _processedMessages[_processedMessages.length - 1];
            }
            if (current.speech_mp3_b64 && !current.text && last) {
                last.speech_mp3_b64 = current.speech_mp3_b64;
            } else {
                _processedMessages.push({ ...current });
            }
        }
        return _processedMessages;
    }, [messages]);

    const [playingIndex, setPlayingIndex] = useState(undefined);
    const lastAudio = useRef(undefined);
    const play = useCallback((index, b64) => {
        if (lastAudio.current) {
            lastAudio.current.pause();
        }
        const audio = new Audio(`data:audio/mpeg;base64,${b64}`);
        audio.onended = () => {
            setPlayingIndex((i) => i === index ? undefined : i);
        }
        audio.play();
        lastAudio.current = audio;
        setPlayingIndex(index);
    }, []);
    const stop = useCallback((index, b64) => {
        lastAudio.current?.pause();
        lastAudio.current = undefined;
        setPlayingIndex(undefined);
    }, []);

    const onClearChatClick = useCallback(() => {
        // if (status === AIChatStatus.idle) {
        clearChat();
        // }
    }, [clearChat]);

    const onAIMicClick = useCallback(() => {
        if (status === AIChatStatus.idle) {
            startListening(l.language);
        }
    }, [status, startListening, l.language]);

    const onAIChatClick = useCallback(() => {
        addNewMessage(chatInput, l.language);
        setChatInput("");
    }, [addNewMessage, chatInput, l.language]);

    const wellcomeText = useMemo(() => {
        var _wellcomeText;
        const hour = (new Date()).getHours();
        if (hour < 11) {
            _wellcomeText = random(s.aiChat.morningWellcomeTexts);
        } else if (hour > 21) {
            _wellcomeText = random(s.aiChat.nightWellcomeTexts);
        } else {
            _wellcomeText = random(s.aiChat.wellcomeTexts);
        }
        // console.log("ai-wellcomeText", _wellcomeText)
        return _wellcomeText;
    }, [s.aiChat]);

    const [icon, infoPlacement, infoText, onChatButtonClick] = useMemo(() => {
        // return [AIMicListening, InfoPlacement.InsteadOfChatInput, s.aiChat.listening, undefined];

        switch (status) {
            case AIChatStatus.listening:
                return [AIMicListening, InfoPlacement.InsteadOfChatInput, s.aiChat.listening, undefined];
            case AIChatStatus.thinking:
                return [AIMicThinking, InfoPlacement.InsteadOfChatInput, s.aiChat.thinking, undefined];
            case AIChatStatus.errorNotAllowed:
                if (chatInput.length > 0) {
                    return [AIWand, InfoPlacement.NoInfo, "", onAIChatClick];
                }
                return [AIMicError, InfoPlacement.TopOfChatInput, s.aiChat.errorNotAllowed, undefined];
            case AIChatStatus.idle:
            default:
                if (chatInput.length > 0) {
                    return [AIWand, InfoPlacement.NoInfo, "", onAIChatClick];
                }
                return [AIMicIdle, InfoPlacement.NoInfo, "", onAIMicClick];
        }
    }, [status, chatInput, s.aiChat, onAIMicClick, onAIChatClick]);


    return (
        <div className="ai-chat-page">
            {showBackground ? <Fragment>
                <div className="bg-blank" />
                <div className="bg-secondary-color" />
            </Fragment> : null}
            <div className={"ai-chat-page-content override-view" + (blurBackground ? " blur-background" : "")}>
                <div className="nav-button" onClick={p.dismiss} />
                <div className="header-group">
                    {blurBackground ?
                        <IconX className="x-icon" /> :
                        <CustomIconBack className="back-icon" />}
                    <div />

                    {/* && (status === AIChatStatus.idle) */}
                    {(messages.length > 0) ?
                        <div className="button-border" onClick={onClearChatClick}>
                            {/* style={{opacity: (status === AIChatStatus.idle) ? 1 : 0.3}}> */}
                            <div className="label">{s.aiChat.newChat}</div>
                            <IconNewChat className="icon" />
                        </div> : null}
                </div>

                {/* {messages.length === 0 ?
                    <div className="examples">
                        <div className="title">{mitooniBegi}</div>
                        <TextLoop children={shuffledExamples} />
                    </div> : null} */}

                {messages.length === 0 ? <div className="wellcome">{wellcomeText}</div> : null}

                <div className="messages">
                    {processedMessages.map((message, index) => {
                        if (message.origin === "user") {
                            return <div key={`ai-chat-message-${index}`} className="user-text">{message.text}</div>;
                        } else if (message.origin === "ai") {
                            return <Fragment key={"ai-index" + String(index)}>
                                {message.logs ? message.logs.map((log, index) => {
                                    return <NewLogCell key={"log_index_" + String(index)} log={log} showSecondsInLog={showSecondsInLog} />
                                }) : null}
                                {message.text ?
                                    <div className="ai-text" key={`ai-chat-message-${index}`}>
                                        {message.speech_mp3_b64 ? (
                                            playingIndex === index ?
                                                <IconPause className="speak-icon" onClick={stop} /> :
                                                <IconSpeak className="speak-icon" onClick={() => play(index, message.speech_mp3_b64)} />
                                        ) : null}
                                        <Markdown remarkPlugins={[remarkGfm]}>{message.text}</Markdown>
                                    </div> : null}

                            </Fragment>;
                        }
                        return null;
                    })}
                    {isStaging && (stats?.text_generation_cost || stats?.speech_generation_cost) ? (
                        <div className="ai-cost">
                            {[
                                stats?.text_generation_cost ? `text: $${stats.text_generation_cost}` : null,
                                stats?.speech_generation_cost ? `speech: $${stats.speech_generation_cost} (speech cost update needs 1min)` : null,
                            ]
                                .filter(Boolean)
                                .join(", ")}
                        </div>
                    ) : null}
                </div>

                {/* <div className={"ai-mic " + (status === AIChatStatus.idle ? "idle" : "")} onClick={onAIChatClick}>
                    {React.createElement(icon, { className: "icon" })}
                    <div className="info">{infoText}</div>
                </div> */}

                <div className="chat-footer">
                    {infoPlacement !== InfoPlacement.InsteadOfChatInput ?
                        <div className="top-label">{infoText}</div> : null}

                    {React.createElement(icon, { className: "icon", onClick: onChatButtonClick })}
                    <div className="box-container">
                        {infoPlacement !== InfoPlacement.InsteadOfChatInput ?
                            <input className="input-box" placeholder={s.aiChat.chat}
                                value={chatInput} onChange={e => setChatInput(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        onChatButtonClick();
                                    }
                                }}></input> :
                            <div className="info-box">
                                {infoText}
                            </div>
                        }
                        {(infoPlacement !== InfoPlacement.InsteadOfChatInput) && (messages.length === 0) ?
                            <div className="animated-box"></div> : null}
                    </div>
                    <div />
                </div>
            </div>
        </div>
    )
}

function random(array) {
    return array[Math.floor(Math.random() * array.length)]
}